module.exports = __webpack_public_path__ + "img/gi.235e5e80.svg";